import { ControllerFlowAPI } from '@wix/yoshi-flow-editor';

import { LOYALTY_APP_DEFINITION_ID, LOYALTY_APP_SECTION_ID } from '../constants';

export interface PageLinks {
  loyaltyPageHref: string;
  loyaltyPageUrl: string;
}

export const getPageLinks = async (flowAPI: ControllerFlowAPI): Promise<PageLinks> => {
  const loyaltyPageLink = await getLoyaltyPageLink(flowAPI);

  return {
    loyaltyPageHref: loyaltyPageLink.href,
    loyaltyPageUrl: loyaltyPageLink.url,
  };
};

interface Link {
  href: string;
  url: string;
}

interface AppSectionParams {
  flowAPI: ControllerFlowAPI;
  appDefinitionId: string;
  sectionId: string;
}

const getAppSectionUrl = async ({ flowAPI, appDefinitionId, sectionId }: AppSectionParams) => {
  const { wixCodeApi } = flowAPI.controllerConfig;

  try {
    return await wixCodeApi.site.getSectionUrl({ appDefinitionId, sectionId });
  } catch {}
};

const getAppPageLink = async ({ flowAPI, appDefinitionId, sectionId }: AppSectionParams): Promise<Link> => {
  const sectionUrl = await getAppSectionUrl({
    flowAPI,
    appDefinitionId,
    sectionId,
  });

  const href = sectionUrl?.url ?? '';
  const url = sectionUrl?.relativeUrl ?? '';

  return { href, url };
};

const getLoyaltyPageLink = async (flowAPI: ControllerFlowAPI) => {
  return getAppPageLink({
    flowAPI,
    appDefinitionId: LOYALTY_APP_DEFINITION_ID,
    sectionId: LOYALTY_APP_SECTION_ID,
  });
};
